import { Request } from "Utils/Request"
import { API_BASE_URL } from 'config.js';

const getPosts = (params, onSuccess, onFail) => {
    return Request({url: API_BASE_URL+'posts', method: 'get', params: params}, onSuccess, onFail);
}

export default {
    getPosts
}